import { useState, useRef, useEffect, useContext } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FaPlus, FaMinus, FaSearch } from 'react-icons/fa';
import 'swiper/css';
import { removeLocalData } from '../utils/localStorageHelper';
import 'swiper/css/navigation';
import { useCart } from '../context/CartContext';
import { useWishlist } from "../context/WishlistContext";
import { getNotification, searchProduct } from '../services/userProfile';
import { useSearch } from '../context/SearchContext';
import { AuthContext } from '../utils/AuthContext';
import { toast } from "react-toastify";
import api from '../api';


const Header = ({ sections }) => {
    const [notifications, setNotifications] = useState([]);
    const [unreadMessage, setUnreadMessage] = useState(0);
    const [showNotifications, setShowNotifications] = useState(false);
    const [currentLocation, setCurrentLocation] = useState(false);
    const [notificationCount, setNotificationCount] = useState([]);
    const { user, setUser, logout } = useContext(AuthContext);
    const { query, setQuery, sectionId, setSectionId } = useSearch();
    const [results, setResults] = useState([]);
    const { wishlistCount, setWishlistCount, clearWishlist } = useWishlist();
    const { cart, updateQuantity, removeFromCart, clearCart } = useCart();
    const { cartCount } = useCart();
    const [openSection, setOpenSection] = useState(null);
    const [showLocationModal, setShowLocationModal] = useState(false);

    console.log("Notification popup >>>", showNotifications);

    const [showMobileProfile, setShowMobileProfile] = useState(false);
    const mobileProfileRef = useRef(null);
    const searchRef = useRef(null);

    const navigate = useNavigate();

    const handleNavigation = (section) => {
        const categoryIds = Array.isArray(section?.categories)
            ? section.categories.map(cat => cat.name)
            : [];
        navigate(`/product-listing/${categoryIds}`, {
            state: { sections: section, categoryIds: categoryIds },
        });
    };

    const goToProductDetails = (item) => {
        var items = item;
        navigate(`/product-details/${items._id}`, { state: { items } });
    }

    const handleLogout = () => {
        removeLocalData("userData");
        clearCart();
        clearWishlist();
        setNotifications([]);
        setUnreadMessage(0);
        logout();
        navigate("/user-login");
    };

    const [isVisible, setIsVisible] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const toggleCart = () => {
        navigate("/add-to-cart");
    };

    const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {

        const storedData = localStorage.getItem("userData");
        const apitoken = storedData ? JSON.parse(storedData).token : null;

        console.log("Token >>>", apitoken);

        const handleOutsideClick = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsHamburgerOpen(false);
            }
        };
        if (isHamburgerOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
            document.addEventListener('touchstart', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, [isHamburgerOpen]);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (mobileProfileRef.current && !mobileProfileRef.current.contains(e.target)) {
                setShowMobileProfile(false);
            }
        };
        if (showMobileProfile) {
            document.addEventListener('mousedown', handleOutsideClick);
            document.addEventListener('touchstart', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, [showMobileProfile]);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (searchRef.current && !searchRef.current.contains(e.target)) {
                setResults([]);
                setQuery('');
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => { setIsVisible(window.scrollY > 300); };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const [selectedCategory, setSelectedCategory] = useState('1');
    const handleCategoryChange = (event) => {
        setSelectedCategory(event.target.value);
    };

    const toggleBoxRef = useRef(null);
    useEffect(() => {
        const el = toggleBoxRef.current;
        if (el) { el.classList.add('highlighted'); }
    }, []);

    const cartTotal = cart.reduce((sum, item) => {
        const price = item.variant?.discountedPrice || 0;
        return sum + price * item.quantity;
    }, 0);

    // ── SEARCH: debounced live results ──
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (query.trim()) {
                handleSearch();
            } else {
                setResults([]);
            }
        }, 300);
        return () => clearTimeout(delayDebounce);
    }, [query, sectionId]);

    const handleSearch = async () => {
        try {
            const res = await searchProduct(query, sections[0]?._id);
            setResults(res.data);
        } catch (err) {
            console.error("Search error:", err);
        }
    };

    // ── SEARCH SUBMIT: Enter key or icon click ──
    // Navigates whether or not dropdown has results
    const handleSearchSubmit = () => {
        if (!query.trim()) return;
        setResults([]);
        setQuery('');
        navigate(`/new-collection?item=${encodeURIComponent(query.trim())}&t=${Date.now()}`);
    };

    // ── DROPDOWN ITEM CLICK ──
    const handleSelect = (item) => {
        setResults([]);
        setQuery('');
        navigate(`/new-collection?item=${encodeURIComponent(item.name)}&t=${Date.now()}`);
    };

    // ── VIEW ALL RESULTS ──
    const handleSelectAll = () => {
        setResults([]);
        setQuery('');
        navigate(`/new-collection`);
    };

    const fetchNotifications = async (token) => {
        try {
            const res = await getNotification(token);
            const notifArray = res.data?.notifications || [];
            const unreadMessage = res.data?.unread_count || 0;
            setNotifications(notifArray);
            setUnreadMessage(unreadMessage);
            setNotificationCount(notifArray.length > 0 ? notifArray.length : 1);
        } catch (error) {
            console.log("Error fetching notifications:", error.message);
        }
    };

    useEffect(() => {
        if (!user) {
            setNotifications([]);
            setUnreadMessage(0);
            return;
        }
        fetchNotifications();
        const interval = setInterval(() => {
            fetchNotifications();
        }, 5000);
        return () => clearInterval(interval);
    }, [user]);

    const readAllNotifications = async () => {
        try {
            const token = user?.token;
            if (!token) return;
            await fetch(`${process.env.REACT_APP_API_URL}user/readAllNotification`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            setUnreadMessage(0);
        } catch (error) {
            console.log("Error marking notifications as read:", error.message);
        }
    };

    const handleOpenNotifications = () => {
        setShowNotifications(true);
        readAllNotifications();
    };

    const handleNotificationClick = async (notif) => {
        const screen = notif?.data?.screen;
        const orderId = notif?.data?.orderId;
        if (!screen) return;
        setShowNotifications(false);
        if (screen === "OrderDetails") {
            const data = await fetchOrderById(orderId);
            const orderData = data?.order;
            navigate(`/order-placed/${orderId}`, { state: { orders: orderData } });
        } else {
            navigate(orderId ? `/${screen}/${orderId}` : `/${screen}`);
        }
    };

    const fetchOrderById = async (orderId) => {
        try {
            const storedData = localStorage.getItem("userData");
            const token = storedData ? JSON.parse(storedData).token : null;
            const res = await api.get(`/user/orderDetails/${orderId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return res.data;
        } catch (error) {
            console.error("Error fetching order details:", error);
        }
    };

    const getMyLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    await fetchAddressFromCoords(latitude, longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    alert("Unable to fetch location. Please enable GPS.");
                },
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
            );
        } else {
            alert("Geolocation is not supported by your browser.");
        }
    };

    const fetchAddressFromCoords = async (lat, lng) => {
        try {
            const apiKey = "AIzaSyCehbIPolbjxmoJobmJv0_8WaAYN504fOE";
            const res = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${Number(lat)},${Number(lng)}&key=${apiKey}`
            );
            const data = await res.json();
            if (data.status === "OK" && data.results.length > 0) {
                const result = data.results[0];
                const components = result.formatted_address || "";
                setCurrentLocation(components);
            } else {
                console.error("Failed to get address:", data.status, data.error_message || "");
            }
        } catch (err) {
            console.error("Error fetching address:", err);
        }
    };

    useEffect(() => { getMyLocation(); }, []);

    const updateCurrentLocation = () => {
        toast.success(`Location Updated Successfully !`, {
            position: "top-right", autoClose: 3000, hideProgressBar: false,
            closeOnClick: true, pauseOnHover: true, draggable: true, theme: "dark",
        });
        getMyLocation();
    }

    // ── Shared notification popup markup ──

    return (
        <>
            <style>{`
            @keyframes marquee {
                0%   { transform: translateX(100%); }
                100% { transform: translateX(-100%); }
            }

            .mobile-header-wrapper {
                display: none;
                position: sticky;
                top: 0;
                z-index: 1040;
                background: #fff;
                box-shadow: 0 2px 8px rgba(0,0,0,0.12);
            }

            .mobile-top-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 8px 12px;
                background: #ceb256;
                gap: 8px;
                overflow: visible;
            }

            .mobile-top-row .mobile-logo img {
                height: 28px;
                width: auto;
                filter: brightness(0) invert(1);
            }

            .mobile-top-row .mobile-icons {
                display: flex;
                align-items: center;
                gap: 14px;
                overflow: visible;
                position: relative;
            }

            .mobile-top-row .mobile-icons > a,
            .mobile-top-row .mobile-icons > button,
            .mobile-top-row .mobile-icons > .mobile-icon-div {
                color: #fff !important;
                background: transparent;
                border: none;
                cursor: pointer;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                font-size: 10px;
                gap: 2px;
                padding: 4px;
                min-width: 36px;
                min-height: 36px;
                -webkit-tap-highlight-color: transparent;
                touch-action: manipulation;
                text-decoration: none;
            }

            .mobile-top-row .mobile-icons > a svg,
            .mobile-top-row .mobile-icons > button svg,
            .mobile-top-row .mobile-icons > .mobile-icon-div > svg {
                color: #fff;
                pointer-events: none;
            }

            .mobile-icon-badge {
                position: absolute;
                top: -2px;
                right: -4px;
                background: #ff6161;
                color: #fff;
                border-radius: 50%;
                width: 17px;
                height: 17px;
                font-size: 10px;
                font-weight: 700;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 1;
                pointer-events: none;
            }

            .mobile-hamburger-btn {
                background: transparent;
                border: none;
                cursor: pointer;
                color: #fff;
                padding: 4px;
                display: flex;
                align-items: center;
                min-width: 36px;
                min-height: 36px;
                -webkit-tap-highlight-color: transparent;
                touch-action: manipulation;
            }

            .mobile-hamburger-btn svg { pointer-events: none; }

            .mobile-location-row {
                display: flex;
                align-items: center;
                background: #ffeca4;
                padding: 4px 12px 6px;
                gap: 6px;
                cursor: pointer;
            }

            .mobile-location-row svg { color: #000000; flex-shrink: 0; }
            .mobile-location-row .mobile-location-label {
                font-size: 11px; color: #000000; font-weight: 600; white-space: nowrap;
            }
            .mobile-location-row .mobile-location-value {
                font-size: 11px; color: #040404; white-space: nowrap;
                overflow: hidden; text-overflow: ellipsis; max-width: calc(100vw - 160px);
            }

            .mobile-search-row {
                padding: 8px 10px;
                background: #fff;
                position: relative;
            }

            .mobile-search-row .mobile-search-input {
                width: 100%; height: 38px; border: 1.5px solid #e0e0e0;
                border-radius: 4px; padding: 0 36px 0 12px; font-size: 13px;
                background: #f5f5f5; outline: none; box-sizing: border-box; transition: border-color 0.2s;
            }

            .mobile-search-row .mobile-search-input:focus {
                border-color: #ceb256; background: #fff;
            }

            .mobile-search-row .mobile-search-icon {
                position: absolute; right: 20px; top: 50%; transform: translateY(-50%);
                color: #ceb256; font-size: 15px;
                cursor: pointer;
                pointer-events: all;
            }

            .mobile-search-row .search__dropdown {
                position: absolute; top: calc(100% - 4px); left: 10px; right: 10px;
                background: #fff; border: 1px solid #e0e0e0;
                border-radius: 0 0 4px 4px;
                box-shadow: 0 4px 12px rgba(0,0,0,0.12); z-index: 999;
                max-height: 260px; overflow-y: auto;
            }

            .mobile-search-row .search__item {
                padding: 10px 14px; font-size: 13px;
                border-bottom: 1px solid #f0f0f0; cursor: pointer;
            }
            .mobile-search-row .search__item:hover { background: #f5f5f5; }
            .mobile-search-row .search__view-all {
                padding: 10px 14px; font-size: 13px;
                color: #ceb256; font-weight: 600; cursor: pointer; text-align: center;
            }

            @media (max-width: 991px) {
                .mobile-header-wrapper { 
               display: block;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                z-index: 9999;
                 }
                
                .main__header.header__sticky { display: none !important; }
                .header__bottom { display: none !important; }
            }

            @media (min-width: 992px) {
                .mobile-header-wrapper { display: none !important; }
            }

            .notification-popup {
                position: fixed; top: 50%; left: 50%;
                transform: translate(-50%, -50%);
                width: 320px; max-width: calc(100vw - 24px);
                max-height: 400px; overflow-y: auto;
                background: #fff; border: 2px solid #ceb256;
                border-radius: 12px; box-shadow: 0 0 16px rgba(0,0,0,0.2);
                z-index: 99999; padding: 15px;
            }

            .notification-overlay {
                position: fixed; inset: 0;
                background: rgba(0,0,0,0.35); z-index: 99998;
            }

            @media (max-width: 991px) {
                .minicart-panel {
                    width: 100% !important; max-width: 100vw !important;
                    border-radius: 0 !important; padding: 16px !important;
                }
            }

            .location-modal-overlay {
                position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 10000;
                display: flex; align-items: center; justify-content: center; padding: 16px;
            }

            .location-modal-box {
                background: #fff; border-radius: 12px; border: 2px solid #ceb256;
                padding: 24px; width: 100%; max-width: 340px;
                box-shadow: 0 8px 32px rgba(0,0,0,0.18);
            }

            @media (max-width: 991px) {
                .offcanvas-sidebar { width: 80vw !important; max-width: 300px !important; }
            }

            .mobile-profile-dropdown {
                position: absolute; top: 40px; right: 0; min-width: 150px;
                background: #fff; border: 1px solid #e0e0e0; border-radius: 8px;
                box-shadow: 0 6px 20px rgba(0,0,0,0.18);
                z-index: 99999; padding: 6px 0; list-style: none; margin: 0;
            }

            .mobile-profile-dropdown li a {
                display: block !important;
                padding: 10px 16px !important;
                font-size: 13px !important;
                color: #333333 !important;
                text-decoration: none !important;
                white-space: nowrap !important;
                background: transparent !important;
                border: none !important;
                min-width: unset !important;
                min-height: unset !important;
                flex-direction: row !important;
            }

            .mobile-profile-dropdown li a:hover,
            .mobile-profile-dropdown li a:active {
                background: #f5f5f5 !important;
                color: #111111 !important;
            }

            .mobile-profile-logout-btn {
                display: block !important; width: 100% !important;
                padding: 10px 16px !important; font-size: 13px !important;
                color: red !important; background: none !important;
                border: none !important; cursor: pointer !important;
                text-align: left !important; white-space: nowrap !important;
                min-width: unset !important; min-height: unset !important;
            }

            .mobile-profile-logout-btn:hover { background: #fff5f5 !important; }
        `}</style>

            {/* ============================================================
                MOBILE HEADER  (visible only on screens < 992px)
            ============================================================ */}
            <div className="mobile-header-wrapper">

                {/* Row 1 — hamburger | logo | icons */}
                <div className="mobile-top-row">

                    <button
                        type="button"
                        className="mobile-hamburger-btn"
                        onClick={() => setIsHamburgerOpen(true)}
                        aria-label="Open menu"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
                            <path fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M80 160h352M80 256h352M80 352h352" />
                        </svg>
                    </button>

                    {/* Logo */}
                    <div className="mobile-logo">
                        <Link to="/"><img src="/assets/img/logo/logo.png" alt="logo" /></Link>
                    </div>

                    {/* Right icons */}
                    <div className="mobile-icons">

                        {/* Home */}
                        <Link to="/" aria-label="Home">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                                <path d="M80 212v236a16 16 0 0016 16h96v-92h88v92h96a16 16 0 0016-16V212" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                <path d="M480 256L266.89 52c-5-5.28-16.69-5.34-21.78 0L48 256M400 179V64h-48v69" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                            </svg>
                        </Link>

                        {/* Wishlist */}
                        <Link to="/wish-list" aria-label="Wishlist" style={{ position: 'relative' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                                <path d="M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                            </svg>
                            {wishlistCount > 0 && (
                                <span className="mobile-icon-badge">{wishlistCount}</span>
                            )}
                        </Link>

                        {/* Notifications */}
                        <button
                            type="button"
                            onClick={handleOpenNotifications}
                            aria-label="Notifications"
                            style={{ position: 'relative' }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                            </svg>
                            {Number(unreadMessage) > 0 && (
                                <span className="mobile-icon-badge">{unreadMessage}</span>
                            )}
                        </button>

                        {/* Cart */}
                        <Link
                            to="#"
                            aria-label="Cart"
                            style={{ position: 'relative' }}
                            onClick={(e) => { e.preventDefault(); toggleCart(); }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 14.706 13.534">
                                <g transform="translate(0 0)">
                                    <path d="M4.738,472.271h7.814a.434.434,0,0,0,.414-.328l1.723-6.316a.466.466,0,0,0-.071-.4.424.424,0,0,0-.344-.179H3.745L3.437,463.6a.435.435,0,0,0-.421-.353H.431a.451.451,0,0,0,0,.9h2.24c.054.257,1.474,6.946,1.555,7.33a1.36,1.36,0,0,0-.779,1.242,1.326,1.326,0,0,0,1.293,1.354h7.812a.452.452,0,0,0,0-.9H4.74a.451.451,0,0,1,0-.9Zm8.966-6.317-1.477,5.414H5.085l-1.149-5.414Z" transform="translate(0 -463.248)" fill="currentColor" />
                                    <path d="M5.5,478.8a1.294,1.294,0,1,0,1.293-1.353A1.325,1.325,0,0,0,5.5,478.8Zm1.293-.451a.452.452,0,1,1-.431.451A.442.442,0,0,1,6.793,478.352Z" transform="translate(-1.191 -466.622)" fill="currentColor" />
                                    <path d="M13.273,478.8a1.294,1.294,0,1,0,1.293-1.353A1.325,1.325,0,0,0,13.273,478.8Zm1.293-.451a.452.452,0,1,1-.431.451A.442.442,0,0,1,14.566,478.352Z" transform="translate(-2.875 -466.622)" fill="currentColor" />
                                </g>
                            </svg>
                            {cartCount > 0 && (
                                <span className="mobile-icon-badge">{cartCount}</span>
                            )}
                        </Link>

                        {/* Profile */}
                        {user ? (
                            <div
                                ref={mobileProfileRef}
                                className="mobile-icon-div"
                                style={{ position: 'relative' }}
                            >
                                <a href="/my-Profile">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                                        <path d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                        <path d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" />
                                    </svg>
                                </a>
                            </div>
                        ) : (
                            <Link to="/user-login" aria-label="Login">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                                    <path d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                    <path d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" />
                                </svg>
                            </Link>
                        )}
                    </div>
                </div>

                {/* Row 2 — Search bar */}
                <div className="mobile-search-row" ref={searchRef}>
                    <input
                        type="text"
                        className="mobile-search-input"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearchSubmit()}
                        placeholder="Search products, brands and more"
                    />
                    {/* ✅ Clickable search icon */}
                    <FaSearch
                        className="mobile-search-icon"
                        onClick={handleSearchSubmit}
                    />

                    {results?.products && results.products.length > 0 && (
                        <div className="search__dropdown border bg-white shadow-sm">
                            {results.products.map((item) => (
                                <div
                                    key={item.id}
                                    className="search__item"
                                    onMouseDown={(e) => e.stopPropagation()}
                                    onTouchStart={(e) => e.stopPropagation()}
                                    onClick={() => handleSelect(item)}
                                >
                                    {item.name} {item.price && <span>&#8377;{item.price}</span>}
                                </div>
                            ))}
                            <div
                                className="search__view-all"
                                onMouseDown={(e) => e.stopPropagation()}
                                onTouchStart={(e) => e.stopPropagation()}
                                onClick={() => handleSelectAll()}
                            >
                                View All Results
                            </div>
                        </div>
                    )}
                </div>

                {/* Notification popup (mobile) */}
                {showNotifications && (
                    <>
                        <div
                            style={{
                                position: "fixed", inset: 0,
                                background: "rgba(0,0,0,0.35)", zIndex: 99998
                            }}
                            onClick={() => setShowNotifications(false)}
                        />
                        <div
                            style={{
                                position: "fixed", top: "50%", left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "320px", maxWidth: "calc(100vw - 24px)",
                                maxHeight: "400px", overflowY: "auto",
                                background: "#fff", border: "2px solid #ceb256",
                                borderRadius: "12px", boxShadow: "0 0 16px rgba(0,0,0,0.2)",
                                zIndex: 99999, padding: "15px"
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                                <button
                                    type="button"
                                    onClick={() => setShowNotifications(false)}
                                    style={{
                                        border: "none", background: "transparent",
                                        cursor: "pointer", fontSize: "26px",
                                        color: "red", lineHeight: 1, padding: "0 4px"
                                    }}
                                >
                                    &times;
                                </button>
                            </div>
                            {notifications.length > 0 ? (
                                notifications.map((notif, index) => (
                                    <div
                                        key={index}
                                        onClick={() => handleNotificationClick(notif)}
                                        style={{
                                            padding: "8px 0",
                                            borderBottom: "1px solid #eee",
                                            cursor: notif?.data?.screen ? "pointer" : "default",
                                        }}
                                        onMouseEnter={e => { if (notif?.data?.screen) e.currentTarget.style.background = "#f9f3e3"; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
                                    >
                                        <strong>{notif?.title}</strong>
                                        <p style={{ margin: "4px 0 0 0", fontSize: "14px" }}>{notif?.body}</p>
                                        <span style={{ fontSize: "12px", color: "#888" }}>
                                            {notif?.sentAt
                                                ? new Date(notif.sentAt).toLocaleString("en-GB", {
                                                    day: "2-digit", month: "2-digit", year: "2-digit",
                                                    hour: "2-digit", minute: "2-digit", hour12: true,
                                                })
                                                : ""}
                                        </span>
                                        {notif?.data?.screen && (
                                            <span style={{ fontSize: "11px", color: "#ceb256", fontWeight: 600, display: "block", marginTop: "3px" }}>
                                                Tap to view →
                                            </span>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <p>No notifications available.</p>
                            )}
                        </div>
                    </>
                )}

            </div>
            {/* ============================================================
                END MOBILE HEADER
            ============================================================ */}


            <header className="header__section">
                <div className="main__header header__sticky">
                    <div className="container-fluid">
                        <div className="main__header--inner position__relative d-flex justify-content-between align-items-center">
                            <div className="offcanvas__header--menu__open ">
                                <Link className="offcanvas__header--menu__open--btn" onClick={() => setIsHamburgerOpen(true)} data-offcanvas>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="ionicon offcanvas__header--menu__open--svg" viewBox="0 0 512 512"><path fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M80 160h352M80 256h352M80 352h352" /></svg>
                                    <span className="visually-hidden">Menu Open</span>
                                </Link>
                            </div>
                            <div className="main__logo">
                                <h1 className="main__logo--title"><Link className="main__logo--link" to="/"><img className="main__logo--img" src="/assets/img/logo/logo.png" alt="logo-img" /></Link></h1>
                            </div>

                            {/* Location Modal */}
                            {showLocationModal && (
                                <div
                                    className="location-modal-overlay"
                                    onClick={() => setShowLocationModal(false)}
                                >
                                    <div
                                        className="location-modal-box"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px" }}>
                                            <h4 style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>&#128205; Current Location</h4>
                                            <button onClick={() => setShowLocationModal(false)} style={{ border: "none", background: "transparent", fontSize: "20px", cursor: "pointer", color: "#e53e3e", lineHeight: 1 }}>&#x2715;</button>
                                        </div>
                                        <p style={{ margin: "0 0 16px 0", fontSize: "14px", color: "#444", lineHeight: "1.6", wordBreak: "break-word" }}>
                                            {currentLocation || "Location not available. Please enable GPS."}
                                        </p>
                                        <button
                                            onClick={() => { updateCurrentLocation(); }}
                                            style={{ width: "100%", padding: "8px", background: "#ceb256", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: 600, fontSize: "14px", color: "#000" }}
                                        >
                                            &#x1F504; Refresh Location
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Desktop Search */}
                            <div className="header__search--widget header__sticky--none d-none d-lg-block">
                                <div className="header__search" style={{ position: "relative", width: "300px" }} ref={searchRef}>
                                    {/* ✅ Clickable desktop search icon */}
                                    <FaSearch
                                        onClick={handleSearchSubmit}
                                        style={{
                                            position: "absolute", right: "10px", top: "50%",
                                            transform: "translateY(-50%)", color: "#666", fontSize: "14px",
                                            cursor: "pointer", pointerEvents: "all", zIndex: 1,
                                        }}
                                    />
                                    <input
                                        type="text"
                                        value={query}
                                        onChange={(e) => setQuery(e.target.value)}
                                        onKeyDown={(e) => e.key === 'Enter' && handleSearchSubmit()}
                                        placeholder="Search products..."
                                        style={{ width: '300px', border: '1px solid #d4af37', borderRadius: '6px' }}
                                    />
                                    {results?.products && results.products.length > 0 && (
                                        <div className="search__dropdown border bg-white shadow-sm">
                                            {results.products.map((item) => (
                                                <div
                                                    key={item.id}
                                                    className="search__item p-2 hover:bg-gray-100"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleSelect(item)}
                                                >
                                                    {item.name} {item.price && <span>&#8377;{item.price}</span>}
                                                </div>
                                            ))}
                                            <div
                                                className="search__view-all p-2 cursor-pointer text-blue-600 hover:underline"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleSelectAll()}
                                            >
                                                View All Results
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="header__account header__sticky--none">
                                <ul className="d-flex align-items-center">
                                    {/* Wish List */}
                                    <li className="header__account--items">
                                        <Link className="header__account--btn" to="/wish-list">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28.51" height="23.443" viewBox="0 0 512 512">
                                                <path d="M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32"></path>
                                            </svg>
                                            <span className="header__account--btn__text">Wish List</span>
                                            <span className="items__count wishlist">{wishlistCount}</span>
                                        </Link>
                                    </li>

                                    {/* Notifications */}
                                    <li className="header__account--items" style={{ position: "relative" }}>
                                        <button
                                            className="header__account--btn"
                                            onClick={handleOpenNotifications}
                                            style={{
                                                background: "transparent", border: "none", cursor: "pointer",
                                                display: "flex", flexDirection: "column", alignItems: "center", position: "relative",
                                            }}
                                        >
                                            <span style={{ position: "relative", display: "inline-block" }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                                </svg>
                                                {Number(unreadMessage) > 0 && (
                                                    <span className="items__count notifications" style={{ position: "absolute", top: "-6px", right: "-12px", background: "#ceb256", color: "#fff", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", lineHeight: "1" }}>
                                                        {unreadMessage}
                                                    </span>
                                                )}
                                            </span>
                                            <span className="header__account--btn__text">Notifications</span>
                                        </button>
                                    </li>

                                    {/* Cart */}
                                    <li className="header__account--items">
                                        <Link
                                            className="header__account--btn minicart__open--btn"
                                            onClick={(e) => { e.preventDefault(); toggleCart(); }}
                                            data-offcanvas
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="26.51" height="23.443" viewBox="0 0 14.706 13.534">
                                                <g transform="translate(0 0)">
                                                    <path d="M4.738,472.271h7.814a.434.434,0,0,0,.414-.328l1.723-6.316a.466.466,0,0,0-.071-.4.424.424,0,0,0-.344-.179H3.745L3.437,463.6a.435.435,0,0,0-.421-.353H.431a.451.451,0,0,0,0,.9h2.24c.054.257,1.474,6.946,1.555,7.33a1.36,1.36,0,0,0-.779,1.242,1.326,1.326,0,0,0,1.293,1.354h7.812a.452.452,0,0,0,0-.9H4.74a.451.451,0,0,1,0-.9Zm8.966-6.317-1.477,5.414H5.085l-1.149-5.414Z" transform="translate(0 -463.248)" fill="currentColor" />
                                                    <path d="M5.5,478.8a1.294,1.294,0,1,0,1.293-1.353A1.325,1.325,0,0,0,5.5,478.8Zm1.293-.451a.452.452,0,1,1-.431.451A.442.442,0,0,1,6.793,478.352Z" transform="translate(-1.191 -466.622)" fill="currentColor" />
                                                    <path d="M13.273,478.8a1.294,1.294,0,1,0,1.293-1.353A1.325,1.325,0,0,0,13.273,478.8Zm1.293-.451a.452.452,0,1,1-.431.451A.442.442,0,0,1,14.566,478.352Z" transform="translate(-2.875 -466.622)" fill="currentColor" />
                                                </g>
                                            </svg>
                                            <span className="header__account--btn__text" style={{ cursor: "pointer" }}>My cart</span>
                                            <span className="items__count"> {cartCount}</span>
                                        </Link>
                                    </li>

                                    <li className="header__account--items">
                                        {user ? (
                                            <>
                                                <div className="customdropdown" style={{ position: "unset" }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="26.51" height="23.443" viewBox="0 0 512 512">
                                                        <path d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                                        <path d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" />
                                                    </svg>
                                                </div>
                                                <div className="header__menu--link">
                                                    <span className="header__account--btn__text" style={{ display: "inline-block", fontSize: "14px", marginLeft: "6px", color: "#000", whiteSpace: "nowrap" }}>
                                                        <a href="/my-Profile">My Profile</a>
                                                    </span>
                                                </div>
                                            </>
                                        ) : (
                                            <Link className="header__account--btn" to="/user-login">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="26.51" height="23.443" viewBox="0 0 512 512">
                                                    <path d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                                    <path d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" />
                                                </svg>
                                                <span className="header__account--btn__text">Login</span>
                                            </Link>
                                        )}
                                    </li>
                                </ul>
                            </div>

                            <div className="header__menu d-none header__sticky--block d-lg-block">
                                <nav className="header__menu--navigation">
                                    <ul className="d-flex">
                                        {sections &&
                                            sections.map((section) => (
                                                <li key={section._id} className="header__menu--items">
                                                    <div
                                                        className="header__menu--link"
                                                        onClick={() => handleNavigation(section)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {section.name}
                                                        {section.categories.length > 0 && (
                                                            <svg className="menu__arrowdown--icon" xmlns="http://www.w3.org/2000/svg" width="12" height="7.41" viewBox="0 0 12 7.41">
                                                                <path d="M16.59,8.59,12,13.17,7.41,8.59,6,10l6,6,6-6Z" transform="translate(-6 -8.59)" fill="currentColor" opacity="0.7" />
                                                            </svg>
                                                        )}
                                                    </div>
                                                    {section.categories.length > 0 && (
                                                        <ul className="header__sub--menu">
                                                            {section.categories.map((cat) => (
                                                                <li key={cat._id} className="header__sub--menu__items">
                                                                    <Link to={`/product-category-list/${cat._id}`} className="header__sub--menu__link">{cat.name}</Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            ))}
                                    </ul>
                                </nav>
                            </div>

                            <div className="header__account header__account2 header__sticky--block">
                                <ul className="d-flex align-items-center">
                                    <li className="header__account--items header__account2--items header__account--search__items d-none d-lg-block">
                                        <Link className="header__account--btn search__open--btn" to="#" data-offcanvas>
                                            <svg className="header__search--button__svg" xmlns="http://www.w3.org/2000/svg" width="26.51" height="23.443" viewBox="0 0 512 512"><path d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" /><path fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M338.29 338.29L448 448" /></svg>
                                            <span className="visually-hidden">Search</span>
                                        </Link>
                                    </li>

                                    {/* Wish List */}
                                    <li className="header__account--items">
                                        <Link className="header__account--btn" to="/wish-list">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28.51" height="23.443" viewBox="0 0 512 512">
                                                <path d="M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32"></path>
                                            </svg>
                                            <span className="header__account--btn__text">Wish List</span>
                                            <span className="items__count wishlist">{wishlistCount}</span>
                                        </Link>
                                    </li>

                                    {/* Notifications */}
                                    <li className="header__account--items" style={{ position: "relative" }}>
                                        <button
                                            className="header__account--btn"
                                            onClick={handleOpenNotifications}
                                            style={{ background: "transparent", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}
                                        >
                                            <span style={{ position: "relative", display: "inline-block" }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                                </svg>
                                                {Number(unreadMessage) > 0 && (
                                                    <span className="items__count notifications" style={{ position: "absolute", top: "-6px", right: "-12px", background: "#ceb256", color: "#fff", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", lineHeight: "1" }}>
                                                        {unreadMessage}
                                                    </span>
                                                )}
                                            </span>
                                            <span className="header__account--btn__text">Notifications</span>
                                        </button>
                                    </li>

                                    {/* Cart */}
                                    <li className="header__account--items">
                                        <Link
                                            className="header__account--btn minicart__open--btn"
                                            onClick={(e) => { e.preventDefault(); toggleCart(); }}
                                            data-offcanvas
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="26.51" height="23.443" viewBox="0 0 14.706 13.534">
                                                <g transform="translate(0 0)">
                                                    <path d="M4.738,472.271h7.814a.434.434,0,0,0,.414-.328l1.723-6.316a.466.466,0,0,0-.071-.4.424.424,0,0,0-.344-.179H3.745L3.437,463.6a.435.435,0,0,0-.421-.353H.431a.451.451,0,0,0,0,.9h2.24c.054.257,1.474,6.946,1.555,7.33a1.36,1.36,0,0,0-.779,1.242,1.326,1.326,0,0,0,1.293,1.354h7.812a.452.452,0,0,0,0-.9H4.74a.451.451,0,0,1,0-.9Zm8.966-6.317-1.477,5.414H5.085l-1.149-5.414Z" transform="translate(0 -463.248)" fill="currentColor" />
                                                    <path d="M5.5,478.8a1.294,1.294,0,1,0,1.293-1.353A1.325,1.325,0,0,0,5.5,478.8Zm1.293-.451a.452.452,0,1,1-.431.451A.442.442,0,0,1,6.793,478.352Z" transform="translate(-1.191 -466.622)" fill="currentColor" />
                                                    <path d="M13.273,478.8a1.294,1.294,0,1,0,1.293-1.353A1.325,1.325,0,0,0,13.273,478.8Zm1.293-.451a.452.452,0,1,1-.431.451A.442.442,0,0,1,14.566,478.352Z" transform="translate(-2.875 -466.622)" fill="currentColor" />
                                                </g>
                                            </svg>
                                            <span className="header__account--btn__text" style={{ cursor: "pointer" }}>My cart</span>
                                            <span className="items__count">{cartCount}</span>
                                        </Link>
                                    </li>

                                    <li className="header__account--items">
                                        {user ? (
                                            <>
                                                <div className="customdropdown" style={{ position: "unset" }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="26.51" height="23.443" viewBox="0 0 512 512">
                                                        <path d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                                        <path d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" />
                                                    </svg>
                                                </div>
                                                <div className="header__menu--link">
                                                    <span className="header__account--btn__text" style={{ display: "inline-block", fontSize: "14px", marginLeft: "6px", color: "#000", whiteSpace: "nowrap" }}>
                                                        Hi,{user.phone}
                                                    </span>
                                                    <ul className="header__submenu">
                                                        <li><a href="/my-Profile">My Profile</a></li>
                                                        <li><a href="/my-orders">My Orders</a></li>
                                                        <li>
                                                            <button
                                                                onClick={() => { handleLogout(); }}
                                                                style={{ background: "none", border: "none", color: "red", cursor: "pointer", padding: "8px 16px", textAlign: "left", width: "100%" }}
                                                                className="header__submenu__logout"
                                                            >
                                                                Logout
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </>
                                        ) : (
                                            <Link className="header__account--btn" to="/user-login">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="26.51" height="23.443" viewBox="0 0 512 512">
                                                    <path d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
                                                    <path d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" />
                                                </svg>
                                                <span className="header__account--btn__text">Login</span>
                                            </Link>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="header__bottom">
                    <div className="container-fluid">
                        <div className="header__bottom--inner position__relative d-none d-lg-flex justify-content-between align-items-center">
                            <div className="header__menu">
                                <nav className="header__menu--navigation">
                                    <ul className="d-flex">
                                        {sections &&
                                            sections.map((section) => (
                                                <li key={section._id} className="header__menu--items">
                                                    <div
                                                        className="header__menu--link"
                                                        onClick={() => handleNavigation(section)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {section.name}
                                                        {section.categories.length > 0 && (
                                                            <svg className="menu__arrowdown--icon" xmlns="http://www.w3.org/2000/svg" width="12" height="7.41" viewBox="0 0 12 7.41">
                                                                <path d="M16.59,8.59,12,13.17,7.41,8.59,6,10l6,6,6-6Z" transform="translate(-6 -8.59)" fill="currentColor" opacity="0.7" />
                                                            </svg>
                                                        )}
                                                    </div>
                                                    {section.categories.length > 0 && (
                                                        <ul className="header__sub--menu">
                                                            {section.categories.map((cat) => (
                                                                <li key={cat._id} className="header__sub--menu__items">
                                                                    <Link to={`/product-category-list/${cat._id}`} className="header__sub--menu__link">{cat.name}</Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            ))}
                                    </ul>
                                </nav>
                            </div>
                            <p className="header__discount--text"><img className="header__discount--icon__img" src="/assets/img/icon/lamp.png" alt="lamp-img" /> We're Launching Link Brand New App  Android and iOS</p>
                        </div>
                    </div>
                </div>

                {/* Offcanvas Sidebar */}
                {isHamburgerOpen && (
                    <div
                        ref={menuRef}
                        className="position-fixed top-0 start-0 h-100 bg-white shadow-lg offcanvas-sidebar"
                        style={{ zIndex: 1050, width: '280px', borderTopRightRadius: '16px', borderBottomRightRadius: '16px', overflowY: 'auto' }}
                    >
                        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                            <Link to="/" className="d-inline-block">
                                <img src="/assets/img/logo/logo.png" alt="Logo" width="158" height="36" />
                            </Link>
                            <button
                                onClick={() => setIsHamburgerOpen(false)}
                                style={{ color: '#000000', border: 'none', backgroundColor: 'transparent' }}
                            >
                                X
                            </button>
                        </div>
                        <nav className="p-3">
                            <ul className="list-unstyled">
                                {sections && sections.map((section) => (
                                    <li key={section._id} className="mb-2">
                                        <div
                                            className="d-flex justify-content-between align-items-center fw-medium"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                                setOpenSection(openSection === section._id ? null : section._id)
                                            }
                                        >
                                            <span>{section.name}</span>
                                            {openSection === section._id ? (
                                                <FaMinus size={18} color="#000000" />
                                            ) : (
                                                <FaPlus size={18} color="#ceb256" />
                                            )}
                                        </div>
                                        {openSection === section._id && section.categories.length > 0 && (
                                            <ul className="ps-3 list-unstyled mt-2">
                                                {section.categories.map((cat) => (
                                                    <li key={cat._id}>
                                                        <hr />
                                                        <Link
                                                            className="text-muted text-decoration-none"
                                                            to={`/product-category-list/${cat._id}`}
                                                            state={{ section: section.name, selectedCategory: cat }}
                                                            onClick={() => setIsHamburgerOpen(false)}
                                                        >
                                                            {cat.name}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                        <hr />
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                )}

                {isOpen && (
                    <div
                        className="position-fixed top-0 end-0 bg-white p-4 shadow rounded minicart-panel"
                        style={{ zIndex: 1055, width: "320px", height: "100vh", transition: "transform 0.3s ease-in-out", transform: isOpen ? "translateX(0)" : "translateX(100%)", overflowY: "auto" }}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <h3 className="mb-0">Shopping Cart</h3>
                            <button className="btn-close" onClick={() => setIsOpen(false)}></button>
                        </div>
                        <p className="minicart__header--desc text-muted">Clothing and fashion products are limited</p>
                        <hr />
                        <div className="mb-3">
                            {cart.length > 0 ? (
                                cart.map((item) => (
                                    <div key={`${item._id}-${item.variant?.color?.name || ''}-${item.variant?.size || "default"}`}>
                                        <div className="d-flex mb-3 align-items-center">
                                            <div className="cart__thumbnail" onClick={() => goToProductDetails(item)}>
                                                <img className="border-radius-5" src={item?.variant?.images?.[0] ?? "https://via.placeholder.com/80x80?text=No+Image"} alt={item.title} />
                                            </div>
                                            <div className="flex-grow-1" style={{ marginLeft: "10px" }}>
                                                <h6 className="mb-1">{item.title}</h6>
                                                <span style={{ float: 'right' }}>{item.category?.name}</span>
                                                <br />
                                                <small className="text-muted">
                                                    &#8377;{item.variant?.discountedPrice}{" "}&times; {item.quantity}
                                                </small>
                                                <span style={{ fontSize: '10px' }}>{item?.name}</span>
                                                <br />
                                                Size: {item.variant?.size}
                                                <div className="mt-2 d-flex align-items-center" style={{ marginTop: '20%' }}>
                                                    <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => updateQuantity(item, item?.variant?.color?.name, item?.variant?.size, item.quantity - 1)} disabled={item.quantity <= 1}>&#8722;</button>
                                                    <span>{item.quantity}</span>
                                                    <button className="btn btn-sm btn-outline-secondary ms-2" onClick={() => updateQuantity(item, item?.variant?.color?.name, item?.variant?.size, item.quantity + 1)} disabled={item.variant?.stock && item.quantity >= item.variant.stock}>+</button>
                                                </div>
                                                <button style={{ marginLeft: '110%' }} className="btn btn-sm btn-danger mt-2" onClick={() => removeFromCart(item, item?.variant?.color?.name, item?.variant?.size)}>Remove</button>
                                            </div>
                                            <span className="fw-bold text-end ms-2" style={{ marginBottom: "32%" }}>
                                                &#8377;{((item.variant?.discountedPrice) * item.quantity).toFixed(2)}
                                            </span>
                                        </div>
                                        <hr />
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-muted py-4">Your cart is empty</p>
                            )}
                        </div>
                        {cart.length > 0 && (
                            <div className="border-top pt-3 mb-3">
                                <p className="fw-bold d-flex justify-content-between">
                                    <span>Total:</span>
                                    <span>&#8377;{cartTotal}</span>
                                </p>
                            </div>
                        )}
                        <div className="d-grid gap-2">
                            <Link
                                className="btn btn-outline-primary"
                                style={{ backgroundColor: "#ceb256", borderColor: "#ceb256", color: "#000" }}
                                to="/add-to-cart"
                                onClick={() => setIsOpen(false)}
                            >
                                View Cart
                            </Link>
                        </div>
                    </div>
                )}

                {/* Notification popup (desktop) */}
                {showNotifications && (
                    <>
                        <div
                            style={{
                                position: "fixed", inset: 0,
                                background: "rgba(0,0,0,0.35)", zIndex: 99998
                            }}
                            onClick={() => setShowNotifications(false)}
                        />
                        <div
                            style={{
                                position: "fixed", top: "50%", left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "320px", maxWidth: "calc(100vw - 24px)",
                                maxHeight: "400px", overflowY: "auto",
                                background: "#fff", border: "2px solid #ceb256",
                                borderRadius: "12px", boxShadow: "0 0 16px rgba(0,0,0,0.2)",
                                zIndex: 99999, padding: "15px"
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                                <button
                                    type="button"
                                    onClick={() => setShowNotifications(false)}
                                    style={{
                                        border: "none", background: "transparent",
                                        cursor: "pointer", fontSize: "26px",
                                        color: "red", lineHeight: 1, padding: "0 4px"
                                    }}
                                >
                                    &times;
                                </button>
                            </div>
                            {notifications.length > 0 ? (
                                notifications.map((notif, index) => (
                                    <div
                                        key={index}
                                        onClick={() => handleNotificationClick(notif)}
                                        style={{
                                            padding: "8px 0",
                                            borderBottom: "1px solid #eee",
                                            cursor: notif?.data?.screen ? "pointer" : "default",
                                        }}
                                        onMouseEnter={e => { if (notif?.data?.screen) e.currentTarget.style.background = "#f9f3e3"; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
                                    >
                                        <strong>{notif?.title}</strong>
                                        <p style={{ margin: "4px 0 0 0", fontSize: "14px" }}>{notif?.body}</p>
                                        <span style={{ fontSize: "12px", color: "#888" }}>
                                            {notif?.sentAt
                                                ? new Date(notif.sentAt).toLocaleString("en-GB", {
                                                    day: "2-digit", month: "2-digit", year: "2-digit",
                                                    hour: "2-digit", minute: "2-digit", hour12: true,
                                                })
                                                : ""}
                                        </span>
                                        {notif?.data?.screen && (
                                            <span style={{ fontSize: "11px", color: "#ceb256", fontWeight: 600, display: "block", marginTop: "3px" }}>
                                                Tap to view →
                                            </span>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <p>No notifications available.</p>
                            )}
                        </div>
                    </>
                )}

                <div className="predictive__search--box ">
                    <div className="predictive__search--box__inner">
                        <h2 className="predictive__search--title">Search Products</h2>
                        <form className="predictive__search--form" action="#">
                            <label>
                                <input className="predictive__search--input" placeholder="Search Here" type="text" />
                            </label>
                            <button className="predictive__search--button" aria-label="search button" type="submit">
                                <svg className="header__search--button__svg" xmlns="http://www.w3.org/2000/svg" width="30.51" height="25.443" viewBox="0 0 512 512"><path d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" /><path fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M338.29 338.29L448 448" /></svg>
                            </button>
                        </form>
                    </div>
                    <button className="predictive__search--close__btn" aria-label="search close button" data-offcanvas>
                        <svg className="predictive__search--close__icon" xmlns="http://www.w3.org/2000/svg" width="40.51" height="30.443" viewBox="0 0 512 512"><path fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M368 368L144 144M368 144L144 368" /></svg>
                    </button>
                </div>

            </header>
        </>
    )
}

export default Header